import Sanscript from '@indic-transliteration/sanscript'

// Live "type in English letters, get native script" input for the alternate
// name fields. An owner on a US keyboard can't produce తెలుగు characters, so
// without this they can only delete from a translated name, never fix it.
//
// Only the Indic scripts where the output is actually good are listed. Urdu and
// Thai are technically supported by the library but come out littered with
// stray diacritics, so they are deliberately left off — those languages (and
// Chinese, Japanese, Korean, Arabic, Russian) use the "Fix with AI" button or
// the operating system's own keyboard instead.
//
// Latin-script languages (Spanish, French, German, Portuguese, Vietnamese,
// Filipino, Somali) need no help — they can be typed directly.
const PHONETIC_SCHEMES = {
  te: 'telugu',
  hi: 'devanagari',
  ta: 'tamil',
  bn: 'bengali',
  gu: 'gujarati',
  pa: 'gurmukhi',
}

export function supportsPhonetic(code) {
  return !!code && !!PHONETIC_SCHEMES[code]
}

// Convert Latin input to the language's script. Returns '' for empty input and
// falls back to the raw text if the library throws, so a bad keystroke can
// never wipe what the owner is typing.
export function transliterate(text, code) {
  const scheme = PHONETIC_SCHEMES[code]
  if (!scheme || !text) return text || ''
  try {
    return Sanscript.t(text, 'itrans', scheme)
  } catch (err) {
    console.error('Transliteration failed:', err)
    return text
  }
}
